module.exports = __webpack_public_path__ + "img/ticket.dd0155ae.png";